import { useWorkStepOptroImport } from "../contexts/workStepOptroImportContext";
import {
  OpsAudit,
  OptroWorkStepSummary,
  WorkStepWithUser,
} from "../models/audit/workStep";
import { useImportPlaceholders } from "./useImportPlaceholders";

const statusRefOf = (summary: OptroWorkStepSummary) => summary.externalRef;
const itemKeyOf = (summary: OptroWorkStepSummary) =>
  String(summary.opsAuditItemId);
const rowKeyOf = (workStep: WorkStepWithUser) => {
  const itemId = workStep.externalRef?.externalOpsAuditItemId;
  return itemId == null ? null : String(itemId);
};

interface UseImportingWorkStepsArgs {
  workSteps: WorkStepWithUser[];
  // Reloaded alongside the work steps: an import can create the audit a
  // landed work step groups under, so its row waits for both.
  opsAudits: OpsAudit[];
  loading: boolean;
  enabled: boolean;
  onItemLanded: () => void;
}

// The Optro work steps of the current import that haven't landed in the Work
// Steps list yet, for placeholder rows, and the loaded list with unfinished
// rows held back. See useImportPlaceholders.
export const useImportingWorkSteps = ({
  workSteps,
  opsAudits,
  loading,
  enabled,
  onItemLanded,
}: UseImportingWorkStepsArgs) => {
  const { placeholderJob, placeholderSummaries } = useWorkStepOptroImport();
  const { visibleRows, importing } = useImportPlaceholders({
    job: placeholderJob,
    startItems: placeholderSummaries,
    rows: workSteps,
    reloadedLists: [workSteps, opsAudits],
    loading,
    enabled,
    onItemLanded,
    statusRefOf,
    itemKeyOf,
    rowKeyOf,
  });
  return {
    visibleWorkSteps: visibleRows,
    importingWorkSteps: importing,
  };
};
